import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";
import { useAuth } from "@/contexts/AuthContext";
import { fmtDateTime } from "@/lib/time";

type Alert = { alert_id: string; device: string; ip: string; created_at: string };

export const LoginAlertBanner = () => {
  const { t, lang } = usePrefs();
  const nav = useNavigate();
  const { user } = useAuth();
  const [rows, setRows] = useState<Alert[]>([]);
  useEffect(() => { api.get("/auth/login-alerts").then((r) => setRows(r.data)).catch(() => {}); }, []);
  if (!rows.length) return null;
  const a = rows[0];
  const drop = () => setRows((x) => x.slice(1));
  const me = async () => {
    try { await api.post(`/auth/login-alerts/${a.alert_id}/confirm`); drop(); } catch (e) { toast.error(errorText(e, t)); }
  };
  const notMe = async () => {
    const cust = !!user && user.role === "customer";
    if (!window.confirm(t(cust ? "la.confirmNotMeCust" : "la.confirmNotMe"))) return;
    try {
      await api.post(`/auth/login-alerts/${a.alert_id}/not-me`);
      if (cust) { drop(); toast.success(t("la.signedOutCust")); nav("/app/profile"); return; }
      setRows([]);
      toast.success(t("la.signedOut"));
      nav(user && user.role === "admin" ? "/admin/settings" : "/venue/settings");
    } catch (e) { toast.error(errorText(e, t)); }
  };
  return (
    <div data-testid="login-alert-banner" className="mb-5 rounded-3xl border border-rose-300 bg-rose-50 dark:bg-rose-500/10 p-4 flex flex-wrap items-center gap-3">
      <ShieldAlert className="h-6 w-6 text-rose-600 shrink-0" />
      <div className="flex-1 min-w-[12rem]">
        <p className="font-bold">{t("la.title")}</p>
        <p className="text-sm text-muted-foreground" data-testid="login-alert-device">
          {t("la.body").replace("{device}", a.device).replace("{time}", fmtDateTime(a.created_at, lang))} <span dir="ltr" className="text-xs">({a.ip})</span>
        </p>
      </div>
      <div className="flex gap-2">
        <button onClick={me} data-testid="login-alert-me" className="h-10 px-4 rounded-full border bg-background text-sm font-bold">{t("la.me")}</button>
        <button onClick={notMe} data-testid="login-alert-not-me" className="h-10 px-4 rounded-full bg-rose-600 text-white text-sm font-bold">{t("la.notMe")}</button>
      </div>
    </div>
  );
};
